<div class="calendar-container">
    <div class="input-wrapper" [class.error]="isError" [class.disabled-wrapper]="!isEnabled">
        <input (click)="showCalendar = !showCalendar" [value]="formatDates(selectedDates)"
            [attr.disabled]="isEnabled ? null : ''" [attr.placeholder]="placeholderText">
        <em class="material-icons today-icon" [class.error-icon]="isError" [class.disabled-icon]="!isEnabled"
            (click)="isEnabled ? showCalendar = !showCalendar : null">today
        </em>
    </div>
    @if(showCalendar) {
    <kendo-calendar (click)="handleClick($event)" (mousedown)="onDateClick($event)" (blur)="onInputBlur()"
        class="custom-calendar" [(ngModel)]="selectedDates" [type]="calendarType" [selection]="selectionMode"
        [disabledDates]="disabledDates" [min]="minDate" [max]="maxDate">
    </kendo-calendar>
    }
</div>